 $(document).ready(function(){
   
   var phonenumber,api_phone, emailID, gender;

    KlaviyoSubscribe.attachToForms('#email_newsletter_sign_page', {
      success: function ($form) {
        $('#email_newsletter_sign_page').hide();
        $('.only_mail_subscribe_success').show();
        $('#send_otp').show();
        var _this = $('#email_newsletter_sign_page');
        var email = _this.find('[name="email"]');      
        var x = true;      
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if(email.val().trim() == '' || !regex.test(email.val())) {
          email.css('border-bottom','1px solid red');        
          x = false;
        } else {
          email.css('border-bottom','1px solid #eaeaea');        
        }
        
        if(x==false) {
          return false;
        }
        emailID = email.val();
        
        gender = _this.find('[name="Gender"]:checked').val();
        
        if(gender == 'Male'){
          gender = '0';
        }else{
          gender = '1';
        } 
        }
    });
   
   $('body').on('submit','#send_otp',function(e){        
      e.preventDefault();
      var _this = $(this);      
      var phone = _this.find('[name="$phone_number"]');
      var sms_checked = '0';
      var c_code = _this.find('.iti__selected-flag').attr('title').split(':');
       _this.find('.err-msg').remove();
      c_code = $.trim(c_code[1]);      
      var x = true;
      var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      if(phone.val().trim() == '') {
        phone.css('border-bottom','1px solid red');        
        x = false;
      } else {
        phone.css('border-bottom','1px solid #eaeaea');        
      }      
      if($('#SMS_UPDATES').is(':checked')){
        sms_checked = '1';
      }
      if(x==false) {
        return false;
      }
      phonenumber = c_code + phone.val();   
      api_phone = phone.val();  
      $.ajax({
        type: 'POST',
        url: 'https://discountapp.manieredevoirtech.com/api/send-otp',  
        headers: {
          "x-shopify-shop": "manieredevoiruk.myshopify.com"
        },
        data: {    
          email: emailID,
          phone: phonenumber,
          api_phone: api_phone,
          sms_updates: sms_checked
        },
        error: function(jqXHR, textStatus, errorThrown){
          if(jqXHR.responseJSON.data.email){
            _this.find('.action_wp').after('<p class="err-msg">'+ jqXHR.responseJSON.data.email +'</p>')          
          }else if(jqXHR.responseJSON.data.phone){
            _this.find('.action_wp').after('<p class="err-msg">'+ jqXHR.responseJSON.data.phone +'</p>')          
          }else if(jqXHR.responseJSON.data.indexOf('Invalid phone') > -1){
            _this.find('.action_wp').after('<p class="err-msg">Invalid Phone Number</p>')          
          }else if(jqXHR.responseJSON.data.indexOf('Error phone check') > -1){
            _this.find('.action_wp').after('<p class="err-msg">Phone already exists. Please add a unique phone number</p>')          
          }else{
            _this.find('.action_wp').after('<p class="err-msg">Please try again..!</p>')          
          }                    
        },
        success: function(response) {
          _this.hide();
          $('#otp_verfication').show();
         $('a.otp_resend_btn').after('<p class="otp_success_msg">OTP is sent successfully</p>');
         $('.otp_success_msg').delay(4000).fadeOut();
        }
      });
    });
   
   $('body').on('submit','#otp_verfication',function(e){        
      e.preventDefault();
      var _this = $(this);
      var otp = _this.find('[name="OTP"]');    
      _this.find('.err-msg').remove();
      var x = true;      
      if(otp.val().trim() == '') {
        otp.css('border-bottom','1px solid red');        
        x = false;
      } else {
        otp.css('border-bottom','1px solid #eaeaea');        
      }
      
      if(x==false) {
        return false;
      }
                  
      $.ajax({
        type: 'POST',
        url: 'https://discountapp.manieredevoirtech.com/api/verify-otp',  
        headers: {
          "x-shopify-shop": "manieredevoiruk.myshopify.com"
        },
        data: {    
          phone: phonenumber,
          otp: otp.val()
        },
        error: function(jqXHR, textStatus, errorThrown){
          if(jqXHR.responseJSON.data.otp){
            _this.find('.action_wp').after('<p class="err-msg">'+ jqXHR.responseJSON.data.otp +'</p>')          
          }else{
            _this.find('.action_wp').after('<p class="err-msg">Please try again..!</p>')          
          }  
        },
        success: function(response) {
          $.ajax({
            type: 'POST',
            url: 'https://discountapp.manieredevoirtech.com/api/generate-discount',  
            headers: {
              "x-shopify-shop": "manieredevoiruk.myshopify.com"
            },
            data: {    
              phone: phonenumber,
              api_phone: api_phone,
              gender: gender
            },
            error: function(jqXHR, textStatus, errorThrown){
              _this.find('.action_wp').after('<p class="err-msg">Email already registered, Please try different email address.</p>')    
            },
            success: function(response) {
              _this.hide();
              $('.third_otp_verification_title').show();
            }
          });
        }
      });
    });
   
   $('body').on('click','.otp_resend_btn',function(e){
     $('.otp_success_msg').remove();
     $('#send_otp').submit();
   });
   
  });